import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '@lingui/core/macro';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useProject } from '../contexts/ProjectContext';
import FontManagement, { FontInfo } from '../components/FontManagement';
import LogoManagement, { LogoInfo } from '../components/LogoManagement';
import { VideoSettingsPanel, VideoSettings } from '../components/VideoSettings';
import { CollapsibleSection } from '../components/CollapsibleSection';
import NavBar from '../components/NavBar';
import './ProjectSettings.css';

interface ProjectSettingsProps {
  fonts: FontInfo[];
  logos: LogoInfo[];
  videoSettings: VideoSettings;
  onFontListChange: (fonts: FontInfo[]) => void;
  onLogoListChange: (logos: LogoInfo[]) => void;
  onVideoSettingsChange: (settings: VideoSettings) => void;
  onFontUploaded?: (fontName: string, serverUrl: string) => void;
  onLogoUploaded?: (logoName: string, serverUrl: string) => void;
  onFontDeleted?: (fontName: string) => void;
  onLogoDeleted?: (logoName: string) => void;
  totalCards?: number;
}

const ProjectSettings: React.FC<ProjectSettingsProps> = ({
  fonts,
  logos,
  videoSettings,
  onFontListChange,
  onLogoListChange,
  onVideoSettingsChange,
  onFontUploaded,
  onLogoUploaded,
  onFontDeleted,
  onLogoDeleted,
  totalCards,
}) => {
  const { selectedProject } = useProject();
  const navigate = useNavigate();

  if (!selectedProject) {
    return null;
  }

  return (
    <div className="project-settings-page">
      <NavBar />
      <div className="project-settings-content">
        <button
          onClick={() => navigate('/app')}
          className="fancy-button"
          style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}
        >
          <ArrowBackIcon style={{ fontSize: '18px' }} />
          {t`Back to Editor`}
        </button>

        <div className="settings-sections">
          <div className="video-settings-section">
            <CollapsibleSection title={String(t`Video Settings`)} contentClassName="video-settings-section-body">
              <VideoSettingsPanel
                settings={videoSettings}
                onSettingsChange={onVideoSettingsChange}
                showTitle={false}
                totalCards={totalCards}
              />
            </CollapsibleSection>
          </div>
          <div style={{rowGap: '14px', display: 'flex', flexDirection: 'column'}}>
          <FontManagement
            onFontListChange={onFontListChange}
            initialFonts={fonts}
            onFontUploaded={onFontUploaded}
            onFontDeleted={onFontDeleted}
          />

          <LogoManagement
            onLogoListChange={onLogoListChange}
            initialLogos={logos}
            onLogoUploaded={onLogoUploaded}
            onLogoDeleted={onLogoDeleted}
          />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSettings;
